<template>
    <button
        type="button"
        class="tier-chip"
        :style="{ background: tier.color, color: tier.textColor }"
        @click="$emit('click', tier)"
    >
        <tier-icon :tier="tier" />
        {{ tier.name }}
    </button>
</template>

<script>
import TierIcon from "./tier-icon";

export default {
    name: "TierChip",
    components: { TierIcon },
    props: {
        tier: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="scss">
.tier-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  max-width: 100%;
  padding: 0.5rem 0.75rem;
  border: none;
  border-radius: 1.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.2;
  text-align: left;
  overflow-wrap: anywhere;
  cursor: pointer;
  filter: drop-shadow(0 5px 23px rgba(0, 0, 0, 0.25));

  .tier-icon {
    font-size: 1.25rem;
  }
}
</style>
